import React from 'react';
import PropTypes from 'prop-types';

import { PowerFunnelSurfaces } from '../../Analytics/constants';
import useIsMobile from '../../hooks/useIsMobile';
import useGlobalPrivilegesCta from '../../hooks/useGlobalPrivilegesCta';
import styles from './marketingBanner.scss';

const MarketingBanner = ({ surface = PowerFunnelSurfaces.HOME, variant = 'marketing' }) => {
    const { isMobileWidth, isTabletWidth } = useIsMobile();
    const {
        buttonText,
        hasPastDueSubscription,
        pastDueSubscriptionMessage,
        handleCtaClick,
    } = useGlobalPrivilegesCta({ surface, variant, trackImpressions: true });

    return (
        <div className={styles.marketingBanner}>
            <div className={`${styles.contentWrapper} ${hasPastDueSubscription ? styles.contentWrapperTall : ''}`}>
                {!isMobileWidth && !isTabletWidth && (
                    <div className={styles.phoneImage}>
                        <img
                            src="/img/v3/graphics/perks/global-privileges/marketing-phone.png"
                            alt="UTR app on phone"
                        />
                    </div>
                )}
                <div className={styles.textContent}>
                    <h2 className={styles.headline} data-testid="banners.marketing.headline">
                        {`Elevate your game & \n your travel experience`}
                    </h2>
                    <p className={styles.subhead} data-testid="banners.marketing.subhead">
                        with access to over $250 of value in travel benefits
                    </p>
                    {!isMobileWidth && (
                        <>
                            {hasPastDueSubscription && <p className={styles.pastDueMessage} data-testid="banners.marketing.past-due-message">{pastDueSubscriptionMessage}</p>}
                            <button
                                className={styles.ctaButton}
                                onClick={handleCtaClick}
                                type="button"
                                data-testid="banners.marketing.cta-btn"
                            >
                                {buttonText}
                            </button>
                        </>
                    )}
                </div>
                {!isMobileWidth && (
                    <div className={styles.playerImage}>
                        <img
                            src="/img/v3/graphics/perks/global-privileges/marketing-player.png"
                            alt="Tennis player"
                        />
                    </div>
                )}
                {isMobileWidth && (
                    <div className={styles.mobileCompositeImage}>
                        <img
                            src="/img/v3/graphics/perks/global-privileges/marketing-mobile-player.png"
                            alt="UTR app and tennis player"
                        />
                    </div>
                )}
                {isMobileWidth && (
                    <>
                        {hasPastDueSubscription && <p className={styles.pastDueMessage} data-testid="banners.marketing.past-due-message">{pastDueSubscriptionMessage}</p>}
                        <button
                            className={styles.ctaButton}
                            onClick={handleCtaClick}
                            type="button"
                            data-testid="banners.marketing.cta-btn"
                        >
                            {buttonText}
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};

MarketingBanner.propTypes = {
    surface: PropTypes.oneOf([PowerFunnelSurfaces.HOME, PowerFunnelSurfaces.POWER_PERKS_PAGE]),
    variant: PropTypes.string,
};

MarketingBanner.defaultProps = {
    surface: PowerFunnelSurfaces.HOME,
    variant: 'marketing',
};

export default MarketingBanner;
